import React from "react"

type ClickOutsideParams = {
  element: React.RefObject<HTMLElement | null>
  disabled?: boolean
  options?: boolean | AddEventListenerOptions
  onClickOutside?: (e: MouseEvent) => void
  onClickInside?: (e: MouseEvent) => void
}

const useClickOutside = ({
  element,
  disabled,
  options,
  onClickOutside,
  onClickInside,
}: ClickOutsideParams) => {
  React.useEffect(() => {
    if (disabled) return undefined
    if (!onClickInside && !onClickOutside) return undefined

    const mouseDownHandler = (event: MouseEvent) => {
      if (!element?.current?.contains(event.target as Node)) {
        onClickOutside?.(event)
        return
      }

      onClickInside?.(event)
    }

    document.addEventListener("mousedown", mouseDownHandler, options)

    return () => {
      document.removeEventListener("mousedown", mouseDownHandler, options)
    }
  }, [element, disabled, options, onClickOutside])
}

export default useClickOutside
